import "./DeliveryPage.css";
import heartLineImg from "../assets/images/heartLineImg.png";
import cargoCircleImg from "../assets/images/cargoCircleImg.png";
import npImg from "../assets/images/npImg.png";
import ukrpImg1 from "../assets/images/ukrpImg1.png";
import ukrpImg2 from "../assets/images/ukrpImg2.png";
import calendar1 from "../assets/images/calendar1.png";
import calendar2 from "../assets/images/calendar2.png";
import machine from "../assets/images/machine.png";
import walletImg from "../assets/images/walletImg.png";
import pointImg from "../assets/images/pointImg.png";
import boxImg from "../assets/images/boxImg.png";
import twoBoxesImg from "../assets/images/twoBoxesImg.png";
import checkImg from "../assets/images/checkImg.png";
import phoneImg from "../assets/images/phoneImg.png";
import SEO from "../components/SEO";
import deliveryImg from "../assets/images/deliveryImg.png"
export default function DeliveryPage() {
  return (
    <div className="delivery-page page-enter">
      <SEO
        title="Доставка та оплата"
        description="Інформація про доставку та оплату з zori.place"
        url="https://zori.place/delivery"
      />
      {/* Hero */}
      <section className="delivery-hero">
<img src={deliveryImg} alt="delivery baner" fetchpriority="high" decoding="async" className="hero-bg" />
        <div className="container delivery-hero-inner">
          <div className="delivery-hero-content">
            <h1 className="delivery-hero-title">Доставка та оплата</h1>
            <img src={heartLineImg} alt="підкресленя" className="delivery-hero-accent" />
            <p className="delivery-hero-desc">
              Ми щиро вдячні вам за те,
              <br />
              що обрали zori.place ♡
            </p>
          </div>
        </div>
      </section>

      {/* Delivery section */}
      <section className="dlv-section">
        <div className="container">
          <div className="dlv-block-header">
            <div className="dlv-block-icon">
              <img src={cargoCircleImg} alt="cargo icon" />
            </div>
            <h2>ДОСТАВКА</h2>
          </div>

          <div className="dlv-carriers">
            <div className="dlv-carriers-col">
              <h4>ПО УКРАЇНІ</h4>
              <div className="dlv-carrier">
                <img src={npImg} alt="nova poshta" className="poshta-img" />
                <span>Нова Пошта</span>
              </div>
              <div className="dlv-carrier">
                <img src={ukrpImg1} alt="ukr poshta icon" className="poshta-img" />
                <span>Укрпошта</span>
              </div>
            </div>
            <div className="dlv-carriers-col">
              <h4>ЗА КОРДОН</h4>
              <div className="dlv-carrier">
                <img src={npImg} alt="nova poshta" className="poshta-img" />
                <span>Nova Poshta Global</span>
              </div>
              <div className="dlv-carrier">
                <img src={ukrpImg2} alt="ukr poshta icon" className="poshta-img" />
                <span>Ukrposhta</span>
              </div>
            </div>
            <div className="dlv-carriers-note">
              <p>Ви можете обрати зручний для вас варіант доставки при оформленні замовлення.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Processing */}
      <section className="dlv-section dlv-section--light">
        <div className="container">
          <div className="dlv-block-header">
            <div className="dlv-block-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <h2>ОПРАЦЮВАННЯ ТА ВИГОТОВЛЕННЯ</h2>
          </div>
          <div className="dlv-processing-grid">
            <div className="dlv-process-item">
              <div className="dlv-process-icon">
                <img src={calendar1} alt="calendar icon" />
              </div>
              <p>
                Опрацювання замовлення <strong>протягом дня після</strong> отримання замовлення.
              </p>
            </div>
            <div className="dlv-process-item">
              <div className="dlv-process-icon">
                <img src={machine} alt="machine icon" />
              </div>
              <p>
                Вся продукція виготовляється індивідуально під замовлення, в наявності позицій не
                тримаємо.
              </p>
            </div>
            <div className="dlv-process-highlight">
              <div className="dlv-process-icon">
                <img src={calendar2} alt="calendar icon" />
              </div>
              <div className="dlv-process-highlight-side">
                <p>Терміни виробництва</p>
                <div className="dlv-process-days">1–3 дні</div>
                <p>з моменту оформлення замовлення.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Info cards */}
      <section className="dlv-section">
        <div className="container">
          <div className="dlv-info-grid">
            {[
              {
                image: walletImg,
                title: "ВАРТІСТЬ ДОСТАВКИ",
                desc: "Вартість доставки — за актуальними тарифами перевізника. За потреби можете уточнити при оформленні замовлення.",
              },
              {
                image: pointImg,
                title: "ВІДСТЕЖЕННЯ ЗАМОВЛЕННЯ",
                desc: "При оформленні замовлення наш менеджер надасть вам попередній трек номер, який активується під час відправки.",
              },
              {
                image: boxImg,
                title: "УПАКУВАННЯ ПРОДУКЦІЇ",
                desc: "Всю нашу продукцію ми надійно пакуємо в матеріал, тому додаткових витрат на пакування ви не отримаєте.",
              },
              {
                image: twoBoxesImg,
                title: "КІЛЬКА ТОВАРІВ В ОДНОМУ ЗАМОВЛЕННІ",
                desc: "Якщо замовлення зроблене на різні категорії товару, пакуємо в одну посилку або відправляємо 2-ма місяцями (якщо можливо для економії коштів за доставку).",
              },
            ].map((c) => (
              <div key={c.title} className="dlv-info-card">
                <img className="dlv-info-icon" src={c.image} alt="іконка інформації" />
                <h4>{c.title}</h4>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Payment */}
      <section className="dlv-section dlv-section--light">
        <div className="container">
          <div className="dlv-payment-grid">
            <img className="dlv-payment-img-left" src={checkImg} alt="іконка чеку" />
            <div className="dlv-payment-description">
              <h2>Оплата та чеки</h2>
              <p>Надаємо електронні чеки на покупку.</p>
            </div>
            <img className="dlv-payment-img-right" src={phoneImg} alt="іконка телефону" />
          </div>
        </div>
      </section>
    </div>
  );
}
